export const LOCALE = 'en';
export const { RAILS_ENV } = global.gon.env;

// Public keys.
export const { RECURLY_PUBLIC_API_KEY, SPLIT_IO_API_KEY } = global.gon.env;

// User
export const USER = global.gon.user;
export const USER_ANALYTICS_ATTRIBUTES = global.gon.user_analytics_attributes;

//Store
export const STORE_CODE = global.gon.storeCode;

// Pod constants.
export const AUTO_SHIP_POD_PRICE = 1359;
export const POD_PRICE = 1599;
export const MAX_POD_QUANTITY = 25;

// Strings.
export const COMPLIANCE_STATE_MESSAGE =
  'To comply with California and Washington state law, your billing and shipping must match. We’ve updated your shipping address for your convenience';
export const CHANGE_OUT_OF_COMPLIANCE_STATE_MESSAGE =
  'You are now able to edit your shipping address. For your convenience, we’ve updated it to match your new billing address.';

// Routing params.
// Names are succinct and generic to keep path helper invocations readable.
export const version = '/:version*';
export const addressType = ':addressType';

// Address constants.
export const ADDRESS_TYPE_BILLING = 'billing';
export const ADDRESS_TYPE_SHIPPING = 'shipping';

// Subscription constants.
export const SUBSCRIPTION_STATUS_ACTIVE = 'active';
export const SUBSCRIPTION_STATUS_CANCELED = 'canceled';

// User roles.
export const ROLE_VIP_CELEBRITY = 'vip_celebrity';

// Base URLs.
export const SUPPORT_SITE_URL = gon.supportSiteUrl;

// URLs
export const AUTOSHIP_URL = `/auto-ship`;
export const AGE_VERIFICATION_URL = `/account/age-verification`;
export const SUPPORT_AUTOSHIP_CANCEL_URL = `${SUPPORT_SITE_URL}/home/orders/autoship/canceling`;
export const SUPPORT_ORDER_RETURNS_URL = `${SUPPORT_SITE_URL}/home/orders/returns-refunds`;
export const SUPPORT_FAQ_URL = `${SUPPORT_SITE_URL}/home/learn/faqs`;
export const TRACKING_URL =
  'http://juulvapor.narvar.com/juulvapor/tracking/USPS?tracking_numbers=';



// WEBPACK FOOTER //
// ./app/javascript/apps/account/appConstants.js